export enum GpsFlags {
  None = 0,
  OdometerEstimated = 1 << 0,
  OdometerOriginationInvalid = 1 << 1,
  OdometerDestinationInvalid = 1 << 4,
  OdometerStuck = 1 << 5,
  OriginationTimeEstimated = 1 << 2,
  OriginationTimeJump = 1 << 3
}

export const HubParametersMapping: Record<GpsFlags, string> = {
  [GpsFlags.None]: 'None',
  [GpsFlags.OdometerEstimated]: 'Odometer Estimated',
  [GpsFlags.OdometerOriginationInvalid]: 'Origination Odometer Invalid',
  [GpsFlags.OdometerDestinationInvalid]: 'Destination Odometer Invalid',
  [GpsFlags.OriginationTimeEstimated]: 'Origination Time Estimated',
  [GpsFlags.OriginationTimeJump]: 'Origination Time Jumped',
  [GpsFlags.OdometerStuck]: 'Odometer Stuck'
};
